import script from "./esMySettingsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esMySettingsSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esMySettingsSettings.vue?vue&type=style&index=0&id=7934ab00&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7934ab00"]])

export default __exports__